import { NavLink } from "react-router-dom";

const Navigation = () => {
  const isMobile = window.innerWidth < 1024;

  return (
    <nav className="flex px-4 py-5 flex-col bg-white lg:flex-row lg:items-center lg:pl-8">
      <div className="flex items-center gap-20">
        <div className="flex gap-5">
          <NavLink to="/" className="flex-shrink-0 my-auto">
            <img
              src="/libra-world.png"
              alt="Libra World Logo"
              className="h-8 w-8"
            />
          </NavLink>
          <NavLink
            to="/"
            className={({ isActive }) =>
              "hidden lg:flex flex-grow text-md font-medium px-3 py-3 text-nowrap " +
              (isActive
                ? "border-b border-[#DE2F32] text-[#292929]"
                : "text-[#424242]")
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/order-book"
            className={({ isActive }) =>
              "flex-grow text-md font-medium px-3 py-3 text-nowrap " +
              (isActive
                ? "border-b border-[#DE2F32] text-[#292929]"
                : "text-[#424242]")
            }
          >
            {isMobile ? "Orders" : "Order Book"}
          </NavLink>
          <NavLink
            to="/transactions"
            className={({ isActive }) =>
              "flex-grow text-md font-medium px-3 py-3 text-nowrap " +
              (isActive
                ? "border-b border-[#DE2F32] text-[#292929]"
                : "text-[#424242]")
            }
          >
            {isMobile ? "Txs" : "Transactions"}
          </NavLink>
          <NavLink
            to="/community-wallets"
            className={({ isActive }) =>
              "flex-grow text-md font-medium px-3 py-3 text-nowrap " +
              (isActive
                ? "border-b border-[#DE2F32] text-[#292929]"
                : "text-[#424242]")
            }
          >
            {isMobile ? "CWs" : "Community Wallets"}
          </NavLink>
          <NavLink
            to="/validators"
            className={({ isActive }) =>
              "flex-grow text-md font-medium px-3 py-3 text-nowrap " +
              (isActive
                ? "border-b border-[#DE2F32] text-[#292929]"
                : "text-[#424242]")
            }
          >
            {isMobile ? "Vals" : "Validators"}
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
